import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'
import CommunityResourcesPlaceholderImage from 'assets/toolkit/community/community_resources_placeholder.png'

interface Breadcrumb {
  label: string
  path: string
}

export const CommunityBasedResourcesPage: React.FC = () => {
  const pageTitle = 'Community-Based Resources'
  const breadcrumbs: Breadcrumb[] = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Community', path: '/toolkit/community' },
    { label: pageTitle, path: '/toolkit/community/community-based-resources' }
  ]

  const resources = [
    {
      title: 'Effectiveness of Infusion Clinic',
      link: '/toolkit/community/effectiveness-of-infusion-clinic',
      imageSrc: CommunityResourcesPlaceholderImage,
      altText: 'Illustration representing effectiveness of infusion clinics'
    },
    {
      title: 'Extension for Community Health Outcomes (ECHO)',
      link: '/toolkit/providers/echo',
      imageSrc: CommunityResourcesPlaceholderImage,
      altText: 'Illustration representing ECHO program'
    },
    {
      title: 'Community Based Organizations',
      link: '/toolkit/community/community-based-organizations-detail',
      imageSrc: CommunityResourcesPlaceholderImage,
      altText: 'Illustration representing community based organizations'
    }
  ]

  return (
    <ToolkitPageLayout title={pageTitle} breadcrumbs={breadcrumbs}>
      <div className="prose max-w-none text-[#3C2416] mb-8">
        <p className="text-xl text-center">
          Leveraging community-based resources is essential for comprehensive
          SCD care and support. This section provides tools and information on
          how to connect with and utilize these valuable assets.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12 mb-12">
        {resources.map((resource, index) => (
          <div
            key={index}
            className="flex flex-col items-center p-6 border border-gray-200 rounded-lg shadow-lg bg-white hover:shadow-xl transition-shadow duration-300"
          >
            <Link
              to={resource.link}
              className="block mb-4 hover:opacity-90 transition-opacity"
            >
              <img
                src={resource.imageSrc}
                alt={resource.altText}
                className="w-full h-48 object-cover rounded-md mb-2 shadow-md"
              />
              <h3 className="text-xl font-semibold text-[#142841] text-center group-hover:text-[#A6410A] transition-colors duration-200">
                {resource.title}
              </h3>
            </Link>
            <Link
              to={resource.link}
              className="mt-auto inline-block bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-5 py-2.5 text-base font-medium transition-colors duration-200 shadow hover:shadow-md"
            >
              Learn More
            </Link>
          </div>
        ))}
      </div>

      {/* All Done Button */}
      <div className="mt-16 mb-8 text-center">
        <Link
          to="/toolkit/community"
          className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-8 py-3 text-lg font-semibold transition-colors duration-200 shadow-lg hover:shadow-xl"
        >
          All done? Click here to return to Community Resources
        </Link>
      </div>
    </ToolkitPageLayout>
  )
}
